import * as Dinamic from "@ali/dinamic";
import { isRTL } from "../utils"

if (isRTL()) {
  Dinamic.setGlobalConfig('__rtl', true)
}

// 表达式：isRTL （判断当前语种是否需要 RTL 的语种，用于镜像处理）
Dinamic.registerDataParser('isRTL', isRTL);

// 表达式： onBindData
Dinamic.registerDataParser('onBindData', () => { });

// 表达式： 判断操作系统（平台）eg. ios/android/h5
Dinamic.registerDataParser('platform', ([data]) => {
  return (data && data.toLowerCase() == 'h5');
});